import { createFileRoute } from '@tanstack/react-router'
import { InvoiceDetailPage } from '@/features/invoices/detail/page'

type InvoiceSearchParams = {
  /** An email to open and highlight, by message id (an action item's link to its source email). */
  message?: string
  /** An action item to bring into view (opened from the Action Items page, USA-1184). */
  action?: string
}

export const Route = createFileRoute('/_authenticated/invoices/$invoiceId')({
  staticData: { title: 'AP Invoice' },
  component: InvoiceDetailRoute,
  validateSearch: (search: Record<string, unknown>): InvoiceSearchParams => ({
    message:
      typeof search.message === 'string' || typeof search.message === 'number'
        ? String(search.message)
        : undefined,
    action: typeof search.action === 'string' ? search.action : undefined,
  }),
})

function InvoiceDetailRoute() {
  const { invoiceId } = Route.useParams()
  const { message, action } = Route.useSearch()
  const messageId = message ? Number(message) : undefined
  return (
    <InvoiceDetailPage
      invoiceId={invoiceId}
      messageId={Number.isInteger(messageId) ? messageId : undefined}
      actionUuid={action}
    />
  )
}
